import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type DeviceCategory =
  | 'phone'
  | 'tablet'
  | 'laptop'
  | 'desktop'
  | 'console'
  | 'wearable'
  | 'watch'
  | 'other';

export const DEVICE_CATEGORIES: DeviceCategory[] = [
  'phone',
  'tablet',
  'laptop',
  'desktop',
  'console',
  'wearable',
  'other',
];

export interface DeviceMake {
  id: string;
  name: string;
  slug: string;
  category?: string | null;
  logoUrl?: string | null;
  sortOrder?: number | null;
  active?: boolean;
  tenantId?: string | null;
  modelCount?: number;
}

export interface DeviceModel {
  id: string;
  makeId: string;
  name: string;
  slug: string;
  releaseYear?: number | null;
  estimatedValue?: string | null;
  category?: string | null;
  imageUrl?: string | null;
  sortOrder?: number | null;
  active?: boolean;
  tenantId?: string | null;
}

export type ListMakesParams = {
  search?: string;
  category?: string;
  includeInactive?: boolean;
  withCounts?: boolean;
};

export type ListModelsParams = {
  makeId?: string;
  category?: string;
  search?: string;
  includeInactive?: boolean;
};

export function listDeviceMakes(params?: ListMakesParams) {
  return apiGet<DeviceMake[]>('/api/v1/devices/makes', {
    params: {
      ...params,
      includeInactive: params?.includeInactive ? 'true' : undefined,
      withCounts: params?.withCounts ? 'true' : undefined,
    },
  }).then((res) => res.data);
}

export function listDeviceModels(params?: ListModelsParams) {
  return apiGet<DeviceModel[]>('/api/v1/devices/models', {
    params: {
      ...params,
      includeInactive: params?.includeInactive ? 'true' : undefined,
    },
  }).then((res) => res.data);
}

export function createDeviceMake(body: {
  name: string;
  category?: DeviceCategory;
  sortOrder?: number;
}) {
  return apiPost<DeviceMake, typeof body>('/api/v1/devices/makes', body).then((r) => r.data);
}

export function updateDeviceMake(
  id: string,
  body: {
    name?: string;
    category?: DeviceCategory | null;
    active?: boolean;
    sortOrder?: number;
  },
) {
  return apiPatch<DeviceMake, typeof body>(`/api/v1/devices/makes/${id}`, body).then((r) => r.data);
}

export function deleteDeviceMake(id: string) {
  return apiDelete<void>(`/api/v1/devices/makes/${id}`);
}

export function createDeviceModel(body: {
  makeId: string;
  name: string;
  category: DeviceCategory;
  releaseYear?: number | null;
  estimatedValue?: number | string | null;
  sortOrder?: number;
}) {
  return apiPost<DeviceModel, typeof body>('/api/v1/devices/models', body).then((r) => r.data);
}

export function updateDeviceModel(
  id: string,
  body: {
    name?: string;
    category?: DeviceCategory;
    releaseYear?: number | null;
    estimatedValue?: number | string | null;
    active?: boolean;
    sortOrder?: number;
  },
) {
  return apiPatch<DeviceModel, typeof body>(`/api/v1/devices/models/${id}`, body).then((r) => r.data);
}

export function deleteDeviceModel(id: string) {
  return apiDelete<void>(`/api/v1/devices/models/${id}`);
}
